import React, { PropTypes } from 'react'
import ReactQuill from 'react-quill'

const Wysiwyg = ({ onChange, value, readOnly, placeholder }) => (
  <ReactQuill
    theme="snow"
    modules={{
      toolbar: [
        'bold',
        'italic',
        { script: 'super' },
        { list: 'ordered' },
        { list: 'bullet' },
        'link',
        'clean',
      ],
    }}
    format={[
      'bold',
      'italic',
      'script',
      'list',
      'bullet',
      'link',
      'clean',
    ]}
    onChange={onChange}
    value={value}
    readOnly={readOnly}
    placeholder={placeholder || ''}
  />
)

Wysiwyg.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
}

export default Wysiwyg




/** WEBPACK FOOTER **
 ** ./src/components/wysiwyg/index.js
 **/